import React from 'react';

const OPTIONS = [
  { id: 'plan', label: 'Plan' },
  { id: 'aerial', label: 'Vue aérienne' },
];

const ViewToggle = ({ view, onChange }) => (
  <div
    role="group"
    aria-label="Fond de carte"
    className="grid grid-cols-2 bg-white/[0.04] border border-[#c9a962]/25 rounded-full p-1"
    data-testid="map-view-toggle"
  >
    {OPTIONS.map((o) => {
      const on = view === o.id;
      return (
        <button
          key={o.id}
          type="button"
          onClick={() => onChange(o.id)}
          aria-pressed={on}
          data-testid={`map-view-${o.id}`}
          className={`min-h-[30px] rounded-full font-montserrat text-[11px] tracking-[0.1em] uppercase transition-colors duration-300
            focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#c9a962]
            ${on ? 'bg-[#c9a962] text-[#0f2419] font-medium' : 'text-white/65 hover:text-white'}`}
        >
          {o.label}
        </button>
      );
    })}
  </div>
);

export default ViewToggle;
